import Card from 'src/components/common/card/Card';
import Typography from 'src/components/common/typography/Typography';
import MarkdownRenderer from 'react-markdown-renderer';

import './aboutMe.scss';
import { processMarkdown } from 'src/constants/typography.constant';

export type TAboutMe = {
  about: string;
};

const AboutMe = ({ about }: TAboutMe) => {
  const processedValue = about ? processMarkdown(about) : '';

  return (
    <Card className="my-profile-about-me">
      <Typography
        as="p"
        variant="body-2"
        fontWeight="semiBold"
        className="my-profile-about-me__heading"
      >
        About Me
      </Typography>
      <Typography
        as="p"
        variant="caption"
        fontWeight="regular"
        className="my-profile-about-me__content"
      >
        {about ? <MarkdownRenderer markdown={processedValue} /> : '-'}
      </Typography>
    </Card>
  );
};

export default AboutMe;
